import _ from 'lodash';

function CreateSubLineController(ValidationService, $window, $state, $scope, $filter, $stateParams, Auth, ClientComponent, TicketComponent, DiscountComponent, PageHeading, Toast, SubLine, ReturnSubLine, SubLineComponent, Currencies, UserComponent) {
	'ngInject';

	const vm = this;
	vm.textValidation = ValidationService.textValidation;
	vm.submitReservation = submitReservation;
	vm.openCreateNewClientForm = openCreateNewClientForm;
	vm.searchClients = ClientComponent.searchClients;
	vm.getResultSearchClients = ClientComponent.getResultSearchClients;
	vm.clearClientResults = ClientComponent.clearResultSearchClients;
	vm.clearUserResults = UserComponent.clearUsers;
	vm.getUsers = UserComponent.getUsers;
	vm.fetchUsers = UserComponent.fetchUsers;
	vm.selectUser = selectUser;
	vm.selectClient = selectClient;
	vm.selectSeat = selectSeat;
	vm.client = {};
	vm.selectedClient = {};
	vm.isValidIdNumber = isValidIdNumber;
	vm.isCurrentUserAgent = _.find(Auth.getCurrentUser().roles, {'name': 'agent'});
	vm.isCurrentUserAgentOffice = Auth.getCurrentUser().roles.length === 1 && Auth.getCurrentUser().roles[0].name ===  'agent';
	vm.discount = {'translation': {'name': $filter('translate')('WITHOUT_DISCOUNT')}};
	vm.subLine = JSON.parse(JSON.stringify(SubLine)); // copy by value not by reference
	vm.returnSubLine = JSON.parse(JSON.stringify(ReturnSubLine)); // copy by value not by reference
	vm.ticketType = $stateParams.ticketType;
	vm.getDiscounts = DiscountComponent.getDiscounts;
	vm.chooseDiscount = chooseDiscount;
	vm.hasPermission = hasPermission;
	vm.seats = [];
	vm.returnSeats = [];
	vm.ticketPrice = [];
	
	activate();

	function activate() {
		const heading = $filter('translate')('SIDEBAR.TICKETS');
		const title = `BTMS | ${$filter('translate')('SIDEBAR.TICKETS')}`;

		ticketPrice();

		PageHeading.setPageHeading(heading, title);

		changeSeatColorsAccordingToPermissions(vm.subLine.seats);

		vm.reservation = {
			'user_id': null,
			'status': !hasPermission(['owner', 'administrator', 'office']) ? 'paid' : '',
			'seats': [{
				'arrives_at': $filter('dateParser')(SubLine.bus.arrives_at, 'YYYY-MM-DD HH:mm:ss'),
				'bus_id': SubLine.bus.id,
				'departs_at': $filter('dateParser')(SubLine.bus.departs_at, 'YYYY-MM-DD HH:mm:ss'),
				'sub_line_id': SubLine.id
			}]
		};

		if ($stateParams.ticketType === 'return') {
			changeSeatColorsAccordingToPermissions(vm.returnSubLine.seats);

			vm.reservation.seats.push({
				'arrives_at': $filter('dateParser')(ReturnSubLine.bus.arrives_at, 'YYYY-MM-DD HH:mm:ss'),
				'bus_id': ReturnSubLine.bus.id,
				'departs_at': $filter('dateParser')(ReturnSubLine.bus.departs_at, 'YYYY-MM-DD HH:mm:ss'),
				'sub_line_id': ReturnSubLine.id
			});
		}
	}

	function submitReservation(selectedClient, newClient, reservation) {
		const isReservationValid = validateReservation(reservation, newClient);
		if (!isReservationValid && !vm.textValidation(vm.client.names)) {
			return false;
		}

		if (selectedClient.id) {
			const areNamesChanged = selectedClient.names !== newClient.names;
			const isIdNumberChanged = selectedClient.id_number !== newClient.id_number;
			const isEmailChanged = selectedClient.email !== newClient.email;
			const isPhoneChanged = selectedClient.phone !== newClient.phone;

			if (areNamesChanged || isIdNumberChanged || isEmailChanged || isPhoneChanged) {
				// Selected client data has been modified. Client should be updated.
				ClientComponent.updateClient(selectedClient.id, newClient)
					.then(function(res) {
						if (res.data.errors) {
							Toast.responseError(res.data.errors);
						} else {
							reservation.client_id = selectedClient.id;
							if ($stateParams.ticketType === 'return') {
								reservation.client_id = selectedClient.id;
							}
							createReservation(reservation);
						}
					});
			} else {
				reservation.client_id = selectedClient.id;
				if ($stateParams.ticketType === 'return') {
					reservation.client_id = selectedClient.id;
				}
				createReservation(reservation);
			}
		} else {
			// There is no selected client. Create new client.
			ClientComponent.createClient(newClient)
				.then(function(res) {
					if (res.data.errors) {
						Toast.responseError(res.data.errors);
					} else {
						reservation.client_id = res.data.data.id;
						if ($stateParams.ticketType === 'return') {
							reservation.client_id = res.data.data.id;
						}
						createReservation(reservation);
					}
				});
		}
	}

	function validateReservation(reservation, newClient) {
		if ($scope.createReservation.$error.required || !isValidIdNumber(newClient.id_number) || !reservation.status) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		if (!reservation.seats[0].number) {
			Toast.error($filter('translate')('ERRORS.REQUIRED_GOING_SEAT'));

			return false;
		}

		if ($stateParams.ticketType === 'return' && !reservation.seats[1].number) {
			Toast.error($filter('translate')('ERRORS.REQUIRED_RETURN_SEAT'));

			return false;
		}

		return true;
	}

	function createReservation(params) {
		params.is_public = 0;

		if (vm.reservation.user_id === '' || vm.userQuery === '') {
			vm.reservation.user_id = null;
		}
		if (vm.reservation.status) {
			TicketComponent.createTicket(params)
				.then(function(res) {
					if (res.data.errors) {
						Toast.responseError(res.data.errors);
					} else {
						Toast.success($filter('translate')('SUCCESS.CREATE_RESERVATION'));
						clearForm();

						SubLineComponent.fetchSubLine($stateParams.subLineId, $stateParams.busId, $stateParams.date)
							.then(function(response) {
								if (response.data && response.data.errors) {
									Toast.responseError(response.data.errors);
									$state.go('app.private.tickets.chooseSubLine');
								} else {
									vm.subLine = response;
									changeSeatColorsAccordingToPermissions(vm.subLine.seats);
									vm.loadSeats();
								}
							});

						if ($stateParams.ticketType === 'return') {
							SubLineComponent.fetchSubLine($stateParams.returnSubLineId, $stateParams.returnBusId, $stateParams.returnDate)
								.then(function(response) {
									if (response.data && response.data.errors) {
										Toast.responseError(response.data.errors);
										$state.go('app.private.tickets.chooseSubLine');
									} else {
										vm.returnSubLine = response;
										changeSeatColorsAccordingToPermissions(vm.returnSubLine.seats);
										vm.loadReturnSeats();
									}
								});
						}
					}
				});
		} else {
			Toast.error($filter('translate')('ERRORS.NO_STATUS'));
		}
	}

	function openCreateNewClientForm() {
		$scope.createReservation.$setPristine();
		vm.client = {};
		vm.selectedClient = {};
		vm.clientQuery = '';
	}

	function selectUser(user) {
		vm.userQuery = user.name || user.names;
		vm.reservation.user_id = user.user[0].id;
	}

	function selectClient(client) {
		vm.clientQuery = client.names;
		vm.selectedClient = client;
		vm.client.names = client.names;
		vm.client.id_number = client.id_number;
		vm.client.email = client.email;
		vm.client.phone = client.phone;
	}

	function isValidIdNumber(idNumber) {
		return /[0-9]/.test(idNumber);
	}

	function clearForm() {
		$scope.createReservation.$setPristine();
		vm.client = {};
		vm.selectedClient = {};
		vm.clientQuery = '';
		vm.userQuery = '';
		vm.discount = {'translation': {'name': $filter('translate')('WITHOUT_DISCOUNT')}};
		vm.reservation.user_id = null;
		delete vm.reservation.ticket_number;
		delete vm.reservation.client_id;
		delete vm.reservation.discount_id;
		delete vm.reservation.seats[0].number;

		if ($stateParams.ticketType === 'return') {
			delete vm.reservation.seats[1].number;
		}
	}

	function selectSeat(seat, direction) {
		let seats = [];

		if (seat.active && seat.color !== 'selected') {
			let selectedSeat = _.where(vm.subLine.seats, { 'number': seat.number });
			
			if (selectedSeat.length > 1) {
				// Warn the user that there are more than one reservation for that seat
				// (multiple subLines)
				Toast.warning($filter('translate')('ERRORS.MULTIPLE_SUBLINES_SEAT'), $filter('translate')('ERRORS.MULTIPLE_SUBLINES_SEAT_TITLE'));
				return false;
			} else if (selectedSeat.length === 1) {
				selectedSeat = selectedSeat[0];
			}

			if ((seat.status === 'paid' || seat.status === 'reserved') && hasPermission(['owner', 'administrator', 'office'])) {
				if ($window.confirm($filter('translate')('CONFIRM.EDIT_SEAT'))) {
					$state.go('app.private.tickets.edit', {'seatId': seat.id});
				} else {
					return false;
				}
			} else if (seat.status !== 'paid' && seat.status === 'reserved' && Auth.getCurrentUser().id === selectedSeat.ticket.user_id) {
				if ($window.confirm($filter('translate')('CONFIRM.EDIT_SEAT'))) {
					$state.go('app.private.tickets.edit', {'seatId': seat.id});
				} else {
					return false;
				}
			} else {
				Toast.error($filter('translate')('ERRORS.TAKEN_SEAT'));

				return false;
			}
		}

		if (direction === 'going') {
			seats = vm.seats;
			vm.reservation.seats[0].number = seat.number;
		} else {
			seats = vm.returnSeats;
			vm.reservation.seats[1].number = seat.number;
		}

		seats.forEach((item) => {
			if (item.active && item.status === 'free') {
				item.active = false;
			}
		});

		seat.active = true;
		seat.color = 'selected';
	}

	/** */
	function chooseDiscount(discount = {}) {
		let discountValue = null;

		if (discount.id) {
			vm.discount = discount;
			vm.reservation.discount_id = discount.id;
			let value = null;
			discountValue = parseInt(discount.value, 10);

			ticketPrice().forEach((currency, index) => {
				if (discount.type === 'value') {
					value = currency.value - discountValue / Currencies[index].exchange_rate;
					currency.value = value.toFixed(2);

					return vm.ticketPrice;
				} else {
					value = currency.value - currency.value / 100 * discountValue;
					currency.value = value.toFixed(2);

					return vm.ticketPrice;
				}
			});
		} else {
			vm.discount = {'translation': {'name': $filter('translate')('WITHOUT_DISCOUNT')}};
			delete vm.reservation.discount_id;

			return  ticketPrice();
		}
	}

	function hasPermission(rolesWithPermission) {
		const currentUserRoles = Auth.getCurrentUser().roles;

		for (let i = 0; i < currentUserRoles.length; i++) {
			if (rolesWithPermission.indexOf(currentUserRoles[i].name) !== -1) {
				return true;
			}
		}

		return false;
	}

	// Agents see each seat as locked (taken)
	// Offices see the seats they sold / reserved and each other seat as locked (taken)
	function changeSeatColorsAccordingToPermissions(seats) {
		if (seats.length && !hasPermission(['owner', 'administrator', 'office'])) {
			seats.forEach((seat) => {
				if (hasPermission(['agent'])) {
					seat.color = 'locked';
				}
			});
		}
	}

/** Create price object set value and currency code
	 * @return { Object } - vm.ticketPrice - Ticket price in different currencies
	*/
	function ticketPrice() {
		vm.ticketPrice = [];
		let price = {};

		for (let i = 0, max = vm.subLine.currencies.length; i < max; i++ ) {
			const oneWayTicket = vm.subLine.currencies[i];
			const returnTicket = vm.returnSubLine.currencies ? vm.returnSubLine.currencies[i] : 0;
			const exchangeRate = Currencies[i].exchange_rate;

			price = {
				'value': sumPrice(oneWayTicket, returnTicket, exchangeRate),
				'code': vm.subLine.currencies[i].code
			};

			vm.ticketPrice.push(price);
		}

		return vm.ticketPrice;
	}

	/** Calculate ticket price
	 * @params { Array } - oneWayTicket - going line
	 * @params { Array } - returnTicket - return line
	 * @return { Number } calculatedPrice - final calculated price
	 */
	function sumPrice(oneWayTicket, returnTicket, rate) {
		const returnTicketDiscount = vm.subLine.return_ticket_discount;
		let calculatedPrice = '';
		let discount = null;
		
		if (returnTicketDiscount.hasOwnProperty('type') && returnTicketDiscount.type === 'value') {			
			discount = returnTicketDiscount.value / rate;
			if ( returnTicket === 0 ) {
				calculatedPrice = oneWayTicket.value;
			} else {
				calculatedPrice = oneWayTicket.value + returnTicket.value - discount;
			}

		}	else {
			discount = returnTicketDiscount.value / rate;

			if ( returnTicket === 0 ) {
				calculatedPrice = oneWayTicket.value;
			} else {
				const totalPrice = oneWayTicket.value + returnTicket.value;

				calculatedPrice = totalPrice - totalPrice  / 100 * discount;
			}

		}

		return calculatedPrice.toFixed(2);
	}
}

export default CreateSubLineController;



/** WEBPACK FOOTER **
 ** ./client/private/tickets/create/create.controller.js
 **/